
export default function About() {
  return (
    <section id="about" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center space-x-2 bg-purple-100 px-4 py-2 rounded-full mb-6">
              <i className="ri-information-line text-purple-600"></i>
              <span className="text-purple-600 text-sm font-semibold">About Us</span>
            </div>
            
            <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Protecting Your Digital Life Since Day One
            </h3>
            
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              At <strong>DULCES SAN JUAN SAS</strong>, we are committed to providing cutting-edge VPN technology that ensures your online privacy and security. Based in Pasto, Colombia, we understand the importance of digital freedom and protection in today's connected world.
            </p>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Our mission is to make the internet a safer place for everyone. We believe that privacy is a fundamental right, and our VPN solution is designed to give you complete control over your online presence while maintaining the highest standards of security and performance.
            </p>

            <div className="grid grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-6 rounded-xl">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-white text-xl"></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-2">100%</h4>
                <p className="text-gray-600">Secure Connection</p>
              </div>
              
              <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-6 rounded-xl">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-global-line text-white text-xl"></i>
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-2">50+</h4>
                <p className="text-gray-600">Server Locations</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/09a21b57d83d83b7fb470dc7d9e03700.jpg"
                alt="VPN Security Technology"
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            <div className="absolute -bottom-8 -left-8 bg-white p-6 rounded-xl shadow-xl border border-gray-100">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-2xl"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Status</p>
                  <p className="text-lg font-bold text-gray-900">Fully Protected</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
